import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TabComp from '../components/Tabs/TabComp';
import Typography from '@mui/material/Typography';
import SmallCards from '../components/Cards/SmallCards';
import ProductCard from '../components/Cards/ProductCard';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import CompareSlider from '../components/Slider/CompareSlider';
import Accordions from '../components/Accordions/Accordions';
import SplitLayout from '../components/Tabs/SplitLayout';
import slitdata from '../data/split.json';
import ContentCard from '../components/Cards/ContentCard';
import { useTranslation } from '../hook/Translation';
export default function DMKSkinRevision() {
const { t } = useTranslation();

    // const cards = [
    //     {
    //         imageUrl: '/images/blank-white-cosmetic-tube-mockup-perfect-skincare-beauty-product-presentation.png',
    //         productType: 'Skin Cushion',
    //         productReviews: 5,
    //         reviewAmount: '45',
    //         productName: 'Pro Lipid Recovery Cream 30ml',
    //         price: 120
    //     },
    //     {
    //         imageUrl: '/images/blank-white-cosmetic-tube-mockup-perfect-skincare-beauty-product-presentation.png',
    //         productType: 'Skin Cushion',
    //         productReviews: 5,
    //         reviewAmount: '45',
    //         productName: 'Pro Lipid Recovery Cream 30ml',
    //         price: 120
    //     },
    //     {
    //         imageUrl: '/images/blank-white-cosmetic-tube-mockup-perfect-skincare-beauty-product-presentation.png',
    //         productType: 'Skin Cushion',
    //         productReviews: 5,
    //         reviewAmount: '45',
    //         productName: 'Pro Lipid Recovery Cream 30ml',
    //         price: 120
    //     }
    // ];
    const imageSet = { before: '/images/mask_1.png', after: '/images/fractional/Mask Group 18.png' }
    const ENZYME_THERAPY = [
        {
            title: 'How it works',
            content: 'The enzyme masque boosts circulation and lymphatic flow, while targeted corrective steps address acne, pigmentation, or signs of aging. Peels and alkaline modalities are added as needed.'
        },
        {
            title: 'Benefits',
            content: 'Improved skin function, clarity, firmness, and resilience.'
        },
        {
            title: 'Areas',
            content: 'Face is primary, with targeted body treatment when indicated.'
        },
        {
            title: 'Pairs with other treatments',
            content: 'Works well before or after laser and RF to prepare the skin and support recovery. Results are supported with DMK home prescriptives.'
        },
        {
            title: 'Downtime details',
            content: 'Usually none. Some corrective peels may cause mild flaking.'
        },
        {
            title: 'When to expect results',
            content: 'Visible improvement after the first session, with cumulative change over a structured program.'
        },
        {
            title: 'Treatment Areas',
            content: 'Most DMK treatments are performed on the face, though Enzyme Therapy can also be done on the body (for example, to firm loose skin on the stomach or to treat back acne). The Alkaline Wash is often used on the face to reduce fine facial hair and can be used anywhere there is a stubborn scar or coarse hair growth.'
        },
    ]
    const tabData = {
        tabs: ["ENZYME THERAPY", "CORRECTIVE PROTOCOL", "RESURFACING PEELS", "FOLLICUZYME", "ALKALINE WASH", "SKIN-NUTRITION FACIAL"],
        context: [
            /*VASCULAR LESION LASER*/
            <Box paddingTop={'84px'} bgcolor={'#f0f0ef'} paddingBottom={'113px'}>
                <Box>
                    <Box className="generalContainer" justifyContent={'center'} marginX={'auto'}>
                        <ContentCard
                            data={{
                                type: 'Pairing',
                                title: 'DMK Enzyme Therapy',
                                imageUrl: '/images/Mask_Group_7.png',
                                description: 'For broken capillaries, angiomas, rosacea vessels and other red blemishes, we use a specialized vascular laser that targets hemoglobin in the blood. The laser light safely collapses unwanted blood vessels, causing visible redness to fade away over days to weeks.'
                            }}
                        />
                    </Box>
                    {/* <Grid container gap={{ md: '40px' }} className='generalContainer' sx={{ marginX: 'auto', marginTop: { md: '120px' } }}>
                        <Grid size={12}>
                            <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>Recommended Products</Typography>
                        </Grid>
                        <Grid size={12}>
                            <ProductCard data={cards} imageHeight={'340px'} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} sizes={{ xs: 12, sm: 6, md: 6, lg: 4 }} bgColor={'#DBDAD9'} />
                        </Grid>
                    </Grid> */}
                </Box>


            </Box>,
            /*PIGMENTATION SPOT LASER*/
            <Box>

            </Box>,
            /*ANTI-FUNGAL NAIL LASER*/
            <Box>

            </Box>
        ]
    };

    const data = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: 'Time',
            description: '45 to 90 min'
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: '45 to 90 min'
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: '45 to 90 min'
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: '45 to 90 min'
        }
    ]

    return (
        <Box>
            <Box>
                <HalfSizeBanner height={{ md: '460px', xs: 'atuo' }}>
                    <Box height={'100%'} bgcolor={'text.secondary'}>
                        <Grid container alignItems={'center'} className='generalContainer' height={'100%'} marginX={'auto'}>
                            <Grid size={{ md: 7, xs: 12 }}>
                                <Grid container spacing={4} paddingY={{ md: 'unset', xs: '30px' }}>
                                    <Grid size={12}>
                                        <Typography variant="h3" className='wColor' fontFamily={'DanmarkURW'} fontSize={{ md: '2.875rem', xs: '1.875rem' }}>DMK Skin Revision (Enzyme & Specialty Treatments)</Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography variant="body1" className='wColor' fontSize={{ md: '1.125rem', xs: '1rem' }}>
                                            Revived skin function and clarity. Our DMK Skin Revision suite is a collection of paramedical treatments from the renowned DMK® brand, designed to “remove, rebuild, protect and maintain” your skin for long-term optimal health. These therapies don’t just work on the surface, they work with your skin’s structure and biology to improve its functioning at a cellular level.
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className='generalContainer' marginX={'auto'} marginTop={'80px'}>
                <Grid container gap={'20px'}>
                    <Grid size={12}>
                        <Typography variant="body1" className='dColor' textAlign={'center'} fontSize={'1.125rem'} fontWeight={'600'}>What Involves</Typography>
                    </Grid>
                    <Grid size={12}>
                        <Typography variant="body1" className='dColor' textAlign={'center'} fontSize={{ md: '1.875rem', xs: '1.125rem' }} fontWeight={'600'}>
                            A DMK-certified esthetician will assess your skin concerns (whether acne, pigmentation, aging, etc.) and tailor a program often starting with DMK’s signature Enzyme Therapy masque. This hard-setting masque creates a pulsating effect that flushes the skin with fresh oxygenated blood and nutrients, kick-starting improved functioning. Depending on your needs, we incorporate various DMK modalities from corrective peels to alkaline treatments that work in synergy.
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            <Box>
                <Box marginTop={{ md: '126px', xs: '' }} className='generalContainer' marginX={'auto'}>
                    <Typography variant="body1" marginBottom={{ md: '75px', xs: '' }} fontWeight={600} className='dColor' textAlign={'center'} fontSize={'1.125rem'}>Key Information</Typography>
                    <SmallCards data={data} />
                </Box>
            </Box>

            <Box marginTop={'100px'}>
                <TabComp tabContext={tabData} bgColor={'#f0f0ef'} />
            </Box>

            <Box bgcolor={'#E9DFD5'}>
                <Grid container spacing={4} className='generalContainer' sx={{ marginX: 'auto', justifyContent: 'center' }} paddingTop={{ md: '82px' }} paddingBottom={{md: '153px'}}>
                    <Grid size={{ md: 8, xs: 12 }}>
                        <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={{ md: '2.875rem', xs: '1.5rem' }} fontWeight={600} marginBottom={'12px'}>Before & After</Typography>
                        <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={{ md: '1.5rem', xs: '1rem' }} fontWeight={600}>The targeted vessels collapse and fade over time, leaving the skin clearer and more even-toned, with less visible redness in the treated area.</Typography>
                    </Grid>
                    <Grid size={{ md: 8, xs: 12 }}>
                        <CompareSlider imageSet={imageSet} height={{ md: '480px', xs: '300px' }} />
                    </Grid>
                </Grid>
            </Box>

            <Box bgcolor={'#FFF'}>
                <Grid container gap={{md: '80px'}} className='generalContainer' sx={{ marginX: 'auto', marginTop: {md: '90px'} }}>
                    <Grid size={12}>
                        <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>Additional Information</Typography>
                    </Grid>
                    <Grid size={12}>
                        <Accordions data={ENZYME_THERAPY} />
                    </Grid>
                </Grid>

                <Grid container spacing={4} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{md: '90px'}} marginBottom={{md: '198px'}}>
                    <Grid size={12}>
                        <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'bold'}>Treatment Areas</Typography>
                        <Typography width={{ md: '80%', xs: '100%' }} textAlign={'center'} marginX={'auto'} marginTop={'20px'} fontSize={{ md: '30px', xs: '1.125rem' }} fontWeight={'600'} variant="body1" color="text.secondary">Anywhere body skin is lax: popular zones include post-baby or post-weight-loss abdomen, upper arms , the knees , thighs and buttocks .We also use it on the neck or chest for clients who have crepe skin there.</Typography>
                    </Grid>
                    <Box gap={'80px'} display={'flex'} flexDirection={'column'} marginTop={'50px'}>
                        {
                            slitdata.map((items, index) => (
                                <SplitLayout key={index} item={items} />
                            ))
                        }
                    </Box>
                </Grid>
            </Box>

        </Box>
    )
}
